import React, { useState } from 'react';
import { getFcListingsInfoPostSale } from '@/api/californiaFC';
import { toast } from 'react-toastify';
import './CAFCSearchSection.css';

const CAFCSearchSection = () => {
  const [formData, setFormData] = useState({
    address: '',
    tsNumber: ''
  });

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const formatCurrency = (amount) => {
    if (amount == null || amount === '') return '';
    const num = Number(String(amount).replace(/[^0-9.-]/g, ''));
    if (isNaN(num)) return amount;
    return num.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const handleInputChange = (e) => {
    console.log('Input change:', e.target.name, e.target.value);
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSearch = async (page = 1) => {
    if (!formData.address && !formData.tsNumber) {
      toast.error('Please enter at least one search field');
      return;
    }

    setLoading(true);
    try {
      const response = await getFcListingsInfoPostSale(formData.address, formData.tsNumber, page);
      
      if (response?.status === 'SUCCESS' && response?.data?.[0]) {
        const { data, totalPages: pages, totalCount: count } = response.data[0];
        setResults(data || []);
        setTotalPages(pages || 0);
        setTotalCount(count || 0);
        setCurrentPage(page);
      } else {
        setResults([]);
        setTotalPages(0);
        setTotalCount(0);
      }
    } catch (error) {
      console.error('Search error:', error);
      toast.error('Search failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      address: '',
      tsNumber: ''
    });
    setResults([]);
    setCurrentPage(1);
    setTotalPages(0);
    setTotalCount(0);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      handleSearch(newPage);
    }
  };

  return (
    <div className="cafc-search-section">
      <div className="search-form">
        <h3>Start Your Search Below:</h3>
        <p>To begin your search, enter at least one of the following fields.</p>
        
        <div className="form-row">
          <input
            type="text"
            name="address"
            id="address"
            placeholder="Enter Address, City, Zip.."
            value={formData.address}
            onChange={handleInputChange}
            onInput={handleInputChange}
            autoComplete="off"
            style={{ pointerEvents: 'auto', zIndex: 1 }}
          />
          <input
            type="text"
            name="tsNumber"
            placeholder="TS Number"
            value={formData.tsNumber}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-buttons">
          <button className="search-btn-cafc" onClick={() => handleSearch()} disabled={loading}>
            {loading ? 'Searching...' : 'Search'}
          </button>
          <button className="reset-btn" onClick={handleReset}>Reset</button>
        </div>
      </div>

      <div className="results-table">
        <table>
          <thead>
            <tr>
              <th>TS Number #</th>
              <th>Property Address</th>
              <th>Sale Held Date</th>
              <th>Final Highest Bid Amount at Sale</th>
              <th>Trustee Address to receive Documents</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>
                  Loading...
                </td>
              </tr>
            ) : results.length > 0 ? (
              results.map((result, index) => (
                <tr key={result.propertyId || index}>
                  <td>{result.caseFileNumber}</td>
                  <td>{result.propertyAddress}</td>
                  <td>{formatDate(result.saleHeldDate)}</td>
                  <td>{formatCurrency(result.finalHighestBidAmountAtSale)}</td>
                  <td>{result.trusteeAddressReceiveDoc}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {totalPages > 1 && (
          <div className="pagination">
            <button 
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1 || loading}
            >
              Previous
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button 
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages || loading}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CAFCSearchSection;